
import React from 'react';
import Grid from '@material-ui/core/Grid';

import Star from './Star';


function ThreeStars({ teams, threeStars, players }) {
  return (
    <Grid container spacing={1}>
      {threeStars.map((star, idx) => {
        const player = players[star];
        const team = teams[player.team];

        return (
          <Grid item xs={12} md={4} key={star}>
            <Star player={player} team={team} star={idx + 1} />
          </Grid>
        )
      })}
    </Grid>
  )
}

export default ThreeStars;
